module.exports = __webpack_public_path__ + "f74623cf46e7812197243b3eb2caedf4.svg";